import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

const langs = ["en", "tr", "ru"];

export const LanguageToggle = () => {
  const { lang, setLang } = useLang();
  const idx = Math.max(0, langs.indexOf(lang));

  return (
    <div
      className="lang-toggle"
      role="group"
      aria-label="Language switch"
      data-testid="language-toggle"
    >
      <motion.div
        className="absolute top-[3px] bottom-[3px] rounded-full"
        style={{
          width: "calc((100% - 6px) / 3)",
          background: "linear-gradient(135deg,#7df9ff,#00f2fe)",
          boxShadow: "0 0 16px rgba(0,242,254,0.5)",
        }}
        animate={{ left: `calc(${idx} * (100% - 6px) / 3 + 3px)` }}
        transition={{ type: "spring", stiffness: 420, damping: 32 }}
      />
      {langs.map((l) => (
        <span
          key={l}
          data-active={lang === l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
        >
          {l.toUpperCase()}
        </span>
      ))}
    </div>
  );
};
